import { ETopic } from '@cian/feedback-form-widget';

import { createStaticReducer } from '../../../../packages/redux-utils';

const defaultState: ETopic | null = null;

export const topicReducer = createStaticReducer<ETopic | null>(defaultState);
